// extracted by mini-css-extract-plugin
export default {"marker":"Map-module-marker","marker--selected":"Map-module-marker--selected"};